import {RootState} from "../index";
import {createSelector} from "reselect";

const deleteBlogModal = (state: RootState) => state.deleteBlogModal;

export const deleteBlogModalSelector = createSelector(
    deleteBlogModal,
    (deleteBlogModal) =>  deleteBlogModal.value
);
